module.exports = __webpack_public_path__ + "img/Simple-Line-Icons.svg?5db2ea1bcb7a6cc078755c90458c3b65";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/simple-line-icons/fonts/Simple-Line-Icons.svg
// module id = 603
// module chunks = 0